import { render, staticRenderFns } from "./FavoriteRoute.vue?vue&type=template&id=11b2aefc&scoped=true"
import script from "./FavoriteRoute.vue?vue&type=script&lang=js"
export * from "./FavoriteRoute.vue?vue&type=script&lang=js"
import style0 from "./FavoriteRoute.vue?vue&type=style&index=0&id=11b2aefc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2aefc",
  null
  
)

export default component.exports